import styled from 'styled-components';

const FAQTitle = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 23px;
  color: #0e141d;
  margin-top: 24px;
  margin-bottom: 16px;
  align-self: flex-start;
`;

const FAQContainer = styled.div`
  border-radius: 8px;
  background: #fff;
  display: grid;
  grid-template-columns: 1fr;
  overflow: hidden;
  ul,
  li {
    list-style: inherit;
    margin-left: 6px;
  }
  ol {
    list-style: decimal;
    margin-left: 6px;
  }
  p {
    line-height: 18px;
  }
`;

const AccordionSkeletonContainer = styled.div`
  border: 1px solid #e2e6ea;
  padding: 16px;
  display: grid;
  background: #fff;
  min-height: 68px;
  grid-template-columns: auto 24px;
  grid-gap: 16px;
  & > div {
    border-radius: 8px;
  }
`;

const AccordionSkeletonStyled = styled.div`
  background-color: #e2e6ea;
  height: auto;
  position: relative;
  overflow: hidden;
  
  background: linear-gradient(90deg, #e2e6ea 0%, #fff 40% , #e2e6ea 60% );
  background-size: 200% 100%;
  background-position: 100% 0;
  animation: load 2s infinite;
  
  @keyframes load {
    100% {
      background-position: -100% 0;;
    }
  }
  
  }
`;
const AccordionSkeletonAnimationArrow = styled(AccordionSkeletonStyled)`
  height: 24px;
  display: flex;
  align-self: center;
`;

export {
  FAQTitle,
  FAQContainer,
  AccordionSkeletonStyled,
  AccordionSkeletonContainer,
  AccordionSkeletonAnimationArrow,
};
